import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import ChatIcon from '@material-ui/icons/Chat';

import TicketsManagerTabs from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";

import { TicketsContext } from "../../context/Tickets/TicketsContext";

import { i18n } from "../../translate/i18n";
const useStyles = makeStyles(theme => ({
    header: {
    },
    content: {
        overflow: "auto"
    },
    placeholderContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        background: theme.palette.type === "dark"
            ? "linear-gradient(135deg, rgba(53, 175, 154, 0.05) 0%, rgba(30, 41, 59, 0.8) 100%)"
            : "linear-gradient(135deg, rgba(53, 175, 154, 0.03) 0%, #F8FAFC 100%)",
        gap: 16,
    },
    placeholderText: {
        fontFamily: '"Inter", "Poppins", sans-serif',
        fontSize: 16,
        fontWeight: 500,
        color: theme.palette.type === "dark" ? "#94A3B8" : "#94A3B8",
    },
    placeholderItem: {
    },
    bottomNav: {
        borderBottom: theme.palette.type === "dark"
            ? "1px solid rgba(255,255,255,0.06)"
            : "1px solid #E2E8F0",
        backgroundColor: theme.palette.background.paper,
        "& .MuiBottomNavigationAction-root": {
            fontFamily: '"Inter", "Poppins", sans-serif',
            fontWeight: 600,
            fontSize: 12,
            color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
            "&.Mui-selected": {
                color: "#35af9a",
            },
        },
    },
    selectButton: {
        borderRadius: 10,
        textTransform: "none",
        fontFamily: '"Inter", "Poppins", sans-serif',
        fontWeight: 600,
        fontSize: 14,
        padding: "8px 24px",
    },
}));

const TicketAdvanced = (props) => {
    const classes = useStyles();
    const { ticketId } = useParams();
    const [option, setOption] = useState(0);
    const { currentTicket, setCurrentTicket } = useContext(TicketsContext)
    const [selectedQueuesMessage, setSelectedQueuesMessage] = useState();

    useEffect(() => {
        if (currentTicket.id !== null) {
            setCurrentTicket({ id: currentTicket.id, code: '#open' })
        }
        if (!ticketId) {
            setOption(1)
        }
        return () => {
            setCurrentTicket({ id: null, code: null })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (currentTicket.id !== null) {
            setOption(0)
        }
    }, [currentTicket])

    useEffect(() => {
        if (ticketId) {
            setOption(0);
        }
    }, [ticketId]);

    const renderPlaceholder = () => {
        return <Box className={classes.placeholderContainer}>
            <div className={classes.placeholderText}>{i18n.t("chat.noTicketMessage")}</div><br />
            <Button
                onClick={() => setOption(1)}
                variant="contained"
                color="primary"
                className={classes.selectButton}
            >
                Selecionar Ticket
            </Button>
        </Box>
    }

    const renderMessageContext = () => {
        if (ticketId) {
            return <Ticket />
        }
        return renderPlaceholder()
    }

    const renderTicketsManagerTabs = () => {
        return <TicketsManagerTabs />
    }

    return (
        <TicketAdvancedLayout>
            <Box className={classes.header}>
                <BottomNavigation
                    value={option}
                    onChange={(event, newValue) => {
                        setOption(newValue);
                    }}
                    showLabels
                    className={classes.bottomNav}
                >
                    <BottomNavigationAction label="Ticket" icon={<ChatIcon />} />
                    <BottomNavigationAction label="Atendimentos" icon={<QuestionAnswerIcon />} />
                </BottomNavigation>
            </Box>
            <Box className={classes.content}>
                {option === 0 ? renderMessageContext() : renderTicketsManagerTabs()}
            </Box>
        </TicketAdvancedLayout>
    );
};

export default TicketAdvanced;
